"use client";
import React from "react";
import { MailOutlined, SkypeOutlined, WhatsAppOutlined, EnvironmentOutlined } from "@ant-design/icons";
import ContactForm from "@/components/InquryForm/ContactForm";
import { useTranslations } from "next-intl";
import CusTitle from "@/components/Home2/CusTitle";
import GetQuteTip from "@/components/Service/CNC/GetQuteTip";
import { contactInfo } from "@/lib/contacts";

const Contact = ({ locale }: { locale: string }) => {
	const t = useTranslations();

	return (
		<div className="bg-white py-12">
			<div className="container grid grid-cols-2 rounded-xl shadow-mainShadow max-md:grid-cols-1">
				<div className="m-5 flex flex-col justify-around border-r-[1.5px] border-r-gray-300 pr-5 max-md:border-none">
					<div>
						<CusTitle homeTitle={t("contactUS.Contact Information")} className="!py-0 text-left"></CusTitle>
						<p className="mt-2 text-left text-gray-500">{t("contactUS.content")}</p>
					</div>

					<div>
						<h3 className="mb-6 text-2xl font-bold">{t("contactUS.ContactInformation")}</h3>
						<ul className="space-y-4">
							<li className="flex items-center text-lg">
								<MailOutlined className="mr-3 rounded-full bg-main p-2 text-xl !text-white" />
								<a href={`mailto:${contactInfo.email}`} className="font-bold text-black hover:text-blue-600">
									{contactInfo.email}
								</a>
							</li>
							{/* <li className="flex items-center text-lg">
								<SkypeOutlined className=" mr-3 rounded-full  bg-main p-2 text-xl !text-white" />
								<span className="font-bold"> {contactInfo.Skype}</span>
							</li> */}
							<li className="flex items-center text-lg">
								<WhatsAppOutlined className="mr-3 rounded-full bg-main p-2 text-xl !text-white" />
								<a
									href={`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, "")}`}
									target="_blank"
									className="font-bold text-black hover:text-blue-600"
								>
									{contactInfo.whatsapp}
								</a>
							</li>
							<li className="flex items-center text-lg">
								<EnvironmentOutlined className="mr-3 rounded-full bg-main p-2 text-xl !text-white" />
								<span className="font-bold text-black">{contactInfo.address}</span>
							</li>
						</ul>
					</div>
					<div>
						<h3 className="mb-6 mt-8 text-2xl font-bold">{t("contactUS.BusinessHours")}</h3>
						<ul className="space-y-2 text-lg">
							<li>
								<span className="text-blue-600">●</span> <strong>{t("contactUS.mTof")}:</strong> 9:00 AM -
								6:00 PM
							</li>
							<li>
								<span className="text-blue-600">●</span> <strong>{t("contactUS.Saturday")}:</strong> 10:00 AM
								- 4:00 PM
							</li>
							<li>
								<span className="text-blue-600">●</span> <strong>{t("contactUS.Sunday")}:</strong>{" "}
								{t("contactUS.Closed")}
							</li>
						</ul>
					</div>
				</div>
				<ContactForm
					locale={locale}
					title={t("base.getInstantQuoteAndTS")}
					titleContent={t("form.fillOutIn")}
					className="!py-0"
					innerClassName="!shadow-none !rounded-none"
				></ContactForm>
			</div>
			<GetQuteTip tip={t("contactUS.tip1")}></GetQuteTip>
		</div>
	);
};

export default Contact;
